import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  setup() {
    if (!import.meta.dev) {
      const router = useRouter()
      Sentry.init({
        // app: [vueApp],
        dsn: `https://986cfbf5fd9c9806dd62842b13aa9042@${import.meta.env.VITE_SENTRY_DOMAIN ? import.meta.env.VITE_SENTRY_DOMAIN : 'ssentry.dom-svc.ru'}/12`,
        environment: import.meta.env.VITE_BRANCH || 'development',

        integrations: [
          Sentry.browserTracingIntegration({ router }),
        ],
        tracesSampleRate: 0.03,
        tracePropagationTargets: [
          'localhost',
          /dom.*\/api/,
          /rtk.*\/api/,
          /mts.*\/api/,
          /beeline.*\/api/,
          /megafon.*\/api/,
          /ttk.*\/api/,
          /graphql/,
        ],
        beforeSend(event, hint) {
          console.log('event')
          console.log(event)
          const ipCookie = useCookie('__ddg9_')
          const ym_uid = useCookie('_ym_uid')
          if (ipCookie.value || ym_uid.value) {
            event.user = {
              ...(event.user || {}),
              ...(ipCookie.value ? { ip_address: ipCookie.value } : {}),
              ...(ym_uid.value ? { ym_uid: ym_uid.value } : {}),
            }

            event.tags = {
              ...(event.tags || {}),
              ...(ym_uid.value ? { ym_uid: ym_uid.value } : {}),
            }
          }
          if (event.exception) {
            console.error(
              `[Exeption handled by Sentry]: (${hint.originalException})`,
              { event, hint },
            )
          }
          if (hint.originalException) {
            console.error('[Exception handled by Sentry]:', hint.originalException)

            if (hint.originalException) {
              try {
                event.extra = {
                  ...event.extra,
                  originalException: JSON.stringify(hint.originalException, (key, value) =>
                    typeof value === 'function' ? value.toString() : value,
                  ),
                }
              }
              catch (e) {
                event.extra = {
                  ...event.extra,
                  originalException: 'Failed to stringify exception',
                }
              }
            }

            // Преобразуем networkError и operation в строки
            if (hint.originalException?.networkError) {
              event.extra.networkError = JSON.stringify(hint.originalException.networkError, null, 2)
            }
            if (hint.originalException?.operation) {
              event.extra.operation = JSON.stringify(hint.originalException.operation, null, 2)
            }
          }
          return event
        },
      })
      return {
        provide: {
          sentryCaptureMessage: Sentry.captureMessage,
        },
      }
    }
    else {
      const captureMessage = (err) => {
        console.log('captureMessage')
        console.log(err)
      }

      return {
        provide: {
          sentryCaptureMessage: captureMessage,
        },
      }
    }
  },
})
